import React from "react";
import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  CardTitle,
  Row,
  Col,
  UncontrolledTooltip,
} from "reactstrap";
import { connect } from "react-redux";
import {
  setupSelectGuild,
  setupSelectServer,
  refreshGuilds,
  deleteServer,
  setListener,
} from "../redux/actions/setup.action";
import { resync } from "../redux/actions/rLink.action";
import discordOwner from "assets/img/discordOwner.png";
import discordNotAllowed from "assets/img/discordNotAllowed.png";
import serverNotConnected from "assets/img/serverNotConnected.png";
import discordNoLogo from "assets/img/discordNoLogo.png";
import ReactBSAlert from "react-bootstrap-sweetalert";

const Setup = (props) => {
  const { t } = useTranslation(["setup", "common", "devices"]);
  const [alert, setAlert] = React.useState(null);
  const deleteConfirmation = (
    id,
    confirmationTitle,
    confirmBtnText,
    successRemoveContent,
    deleteFunc,
  ) => {
    setAlert(
      <ReactBSAlert
        warning
        style={{ display: "block", marginTop: "-100px" }}
        title={t(confirmationTitle)}
        onConfirm={() => successRemove(id, successRemoveContent, deleteFunc)}
        onCancel={() => cancelRemove()}
        confirmBtnBsStyle="success"
        cancelBtnBsStyle="danger"
        confirmBtnText={t(confirmBtnText)}
        cancelBtnText={t("common:cancel")}
        showCancel
        btnSize=""
      ></ReactBSAlert>,
    );
  };

  const successRemove = (id, successRemoveContent, deleteFunc) => {
    setAlert(
      <ReactBSAlert
        success
        style={{ display: "block", marginTop: "-100px" }}
        title={t("common:removed")}
        onConfirm={() => hideAlert(id, deleteFunc)}
        onCancel={() => hideAlert()}
        confirmBtnBsStyle="success"
        btnSize=""
      >
        {t(successRemoveContent)}
      </ReactBSAlert>,
    );
  };
  const cancelRemove = () => {
    setAlert(
      <ReactBSAlert
        danger
        style={{ display: "block", marginTop: "-100px" }}
        title={t("common:cancelled")}
        onConfirm={() => hideAlert()}
        onCancel={() => hideAlert()}
        confirmBtnBsStyle="success"
        btnSize=""
      ></ReactBSAlert>,
    );
  };

  const hideAlert = (id = false, deleteFunc = false) => {
    setAlert(null);
    if (id && deleteFunc) {
      deleteFunc(id);
    }
  };
  return (
    <>
      {alert}
      <div className="content">
        <motion.div
          initial={{ opacity: 0.5, x: -100 }}
          animate={{ opacity: 1, x: 0, transition: { duration: 0.5 } }}
        >
          {props.vip.plan > 0 && (
            <Card className="cardFCM">
              <CardHeader>
                <CardTitle tag="h4">{t("fcmListener")}</CardTitle>
              </CardHeader>
              <CardBody>
                <Row>
                  <Col xs="12" md="8" className="fcmDesc">
                    <div
                      className={`fcmMsg ${
                        props.listener ? "enabled" : "disabled"
                      }`}
                    >
                      {t(`${props.listener ? "enabled" : "disabled"}`)}
                    </div>
                    <div className={`fcmMsg warning`}>
                      {t("rustPlusDisconnect")}
                    </div>
                  </Col>
                  <Col xs="12" md="4" className="fcmBtn">
                    {props.vip.canResync > 0 && (
                      <Button
                        onClick={() => props.resync()}
                        className="btnResync"
                      >
                        {t("resyncBtn")}
                      </Button>
                    )}
                    <Button
                      onClick={() => props.setListener(!props.listener)}
                      className={props.listener ? "btnDisable" : "btnEnable"}
                    >
                      {t(`${props.listener ? "disableBtn" : "enableBtn"}`)}
                    </Button>
                  </Col>
                </Row>
              </CardBody>
            </Card>
          )}
        </motion.div>
        <motion.div
          initial={{ opacity: 0.5, x: -100 }}
          animate={{ opacity: 1, x: 0, transition: { duration: 0.5 } }}
        >
          <Card>
            <CardHeader>
              <CardTitle tag="h4">{t("discordSelectServer")}</CardTitle>
              {props.vip.plan < 1 && (
                <h5 class="controlledBy">{t("cantSelectDiscord")}</h5>
              )}
            </CardHeader>
            <CardBody>
              <Row>
                {props.guildsList.length > 0 &&
                  !props.selectedGuilds.length && (
                    <Col md="12" className="guildError guildErrorMargin">
                      {t("noGuildSelected")}
                    </Col>
                  )}
                {!props.guildsList.length && (
                  <Col md="12" className="guildError">
                    {t("noGuildAdded")}
                  </Col>
                )}
                {props.guildsList.map((guild, key) => {
                  const isSelectable = guild.selectable
                    ? true
                    : guild.selected
                      ? true
                      : false;
                  return (
                    <Col
                      xl="4"
                      lg="6"
                      md="12"
                      onClick={() => {
                        if (!isSelectable) return;
                        if (guild.currentUser && !guild.selected)
                          deleteConfirmation(
                            guild.id,
                            "common:confirmTitleRetakeDiscord",
                            "common:confirmYesRetakeDiscord",
                            "common:discordRetaked",
                            props.setupSelectGuild,
                          );
                        else props.setupSelectGuild(guild.id);
                      }}
                    >
                      <motion.div
                        whileHover={{ scale: isSelectable ? 1.03 : 1.0 }}
                        whileTap={{ scale: isSelectable ? 0.97 : 1.0 }}
                        initial={{ scale: 0 }}
                        animate={{ scale: 1 }}
                        transition={{ duration: 0.1 }}
                      >
                        <Card
                          className={`${
                            props.vip.plan > 0 &&
                            guild.selectable &&
                            `selectable`
                          } ${
                            guild.selected && `setupServerSelected selectable`
                          }`}
                        >
                          <CardBody>
                            <Row>
                              <Col xs="4">
                                {
                                  <img
                                    className="discordImg"
                                    alt="guild-icon"
                                    src={
                                      guild.icon ? guild.icon : discordNoLogo
                                    }
                                  />
                                }
                              </Col>
                              <Col xs="6" className="discordName">
                                <div className="name c-white">{guild.name}</div>
                                {guild.currentUser && !guild.selected && (
                                  <small className="controlledBy">{`${t(
                                    "controlledBy",
                                  )} ${guild.currentUser}`}</small>
                                )}
                                {isSelectable && !guild.currentUser && (
                                  <small className="controlledBy">
                                    {t("controlledByNobody")}
                                  </small>
                                )}
                              </Col>
                              <Col xs="2" className="m-auto">
                                {guild.admin && (
                                  <img
                                    className="discordOwner"
                                    id={`owner-${guild.id}`}
                                    alt="owner-icon"
                                    src={discordOwner}
                                  />
                                )}
                                {guild.admin && (
                                  <UncontrolledTooltip
                                    delay={0}
                                    target={`owner-${guild.id}`}
                                  >
                                    Discord admin
                                  </UncontrolledTooltip>
                                )}
                                {!isSelectable && (
                                  <img
                                    className="discordNotAllowed"
                                    id={`NotAllowed-${guild.id}`}
                                    alt="notallowed-icon"
                                    src={discordNotAllowed}
                                  />
                                )}
                                {!isSelectable && (
                                  <UncontrolledTooltip
                                    delay={0}
                                    target={`NotAllowed-${guild.id}`}
                                  >
                                    {t("notAllowed")}
                                  </UncontrolledTooltip>
                                )}
                              </Col>
                            </Row>
                          </CardBody>
                        </Card>
                      </motion.div>
                    </Col>
                  );
                })}
              </Row>
            </CardBody>

            <div className="discordBtns">
              <motion.div
                className="d-flex"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1, transition: { duration: 1.5 } }}
              >
                <Button
                  className="discordBtn"
                  color="discord"
                  onClick={() =>
                    props.vip.plan < 1
                      ? toast.info(t("cantSelectDiscord"))
                      : window.open("https://rustlink.io/bot", "_blank")
                  }
                >
                  <i className="fab fa-discord" />
                  {t("addNewDiscord")}
                </Button>
                {props.vip.plan > 0 && (
                  <Button
                    className="discordBtn"
                    color="discord"
                    onClick={() => props.refreshGuilds()}
                  >
                    <i className="fas fa-sync" />
                    {t("common:refresh")}
                  </Button>
                )}
              </motion.div>
            </div>
          </Card>
        </motion.div>
        <motion.div
          initial={{ opacity: 0.5, x: 100 }}
          animate={{ opacity: 1, x: 0, transition: { duration: 0.5 } }}
        >
          <Card>
            <CardHeader>
              <CardTitle tag="h4">{t("rustSelectServer")}</CardTitle>
              {props.vip.plan < 1 && (
                <h5 class="controlledBy">{t("cantSelectRustServer")}</h5>
              )}
            </CardHeader>
            <CardBody>
              <Row>
                {!props.selectedServer && (
                  <Col md="12" className="guildError guildErrorMargin">
                    {t("noRustServerSelected")}
                  </Col>
                )}
                {props.serversList &&
                  props.serversList.length > 0 &&
                  props.serversList.map((server, key) => {
                    const isSelected = props.selectedServer === server.id;
                    const isSelectable = isSelected
                      ? false
                      : server.connected
                        ? true
                        : false;
                    return (
                      <Col xl="6" lg="6" md="12">
                        <motion.div
                          whileHover={{ scale: isSelectable ? 1.03 : 1.0 }}
                          whileTap={{ scale: isSelectable ? 0.97 : 1.0 }}
                          initial={{ scale: 0 }}
                          animate={{ scale: 1 }}
                          transition={{ duration: 0.1 }}
                        >
                          <Card
                            className={`c-white ${
                              isSelected && `setupServerSelected`
                            }`}
                          >
                            <CardBody>
                              <Row className="cardServer">
                                <Col
                                  xs="8"
                                  className={`serverName serverMargin ${
                                    isSelectable || isSelected
                                      ? `selectable`
                                      : ``
                                  }`}
                                  onClick={() =>
                                    props.setupSelectServer(server.id)
                                  }
                                >
                                  {server.name}
                                </Col>
                                <Col
                                  xs="3"
                                  className={`serverPlayers m-auto text-center ${
                                    isSelectable || isSelected
                                      ? `selectable`
                                      : ``
                                  }`}
                                  onClick={() =>
                                    props.setupSelectServer(server.id)
                                  }
                                >
                                  <div
                                    className={`${
                                      (!server.connected || !server.players) &&
                                      `hidden`
                                    }`}
                                  >
                                    {t("players")}
                                  </div>
                                  <div
                                    className={`${
                                      (!server.connected || !server.players) &&
                                      `hidden`
                                    }`}
                                  >
                                    {server.players}/{server.maxPlayers}
                                  </div>
                                  {
                                    <div
                                      className={`${
                                        server.connected && `hidden`
                                      }`}
                                    >
                                      <img
                                        className="serverNotConnected"
                                        id={`NotConnected-${server.id}`}
                                        alt="NotConnected-icon"
                                        src={serverNotConnected}
                                      />
                                    </div>
                                  }
                                </Col>
                                <Col
                                  xs="1"
                                  className="serverRemoveIcon"
                                  onClick={() =>
                                    deleteConfirmation(
                                      server.id,
                                      "common:confirmUnlist",
                                      "common:confirmYes",
                                      "deletedSuccess",
                                      props.deleteServer,
                                    )
                                  }
                                >
                                  <i className="tim-icons icon-simple-remove" />
                                </Col>
                              </Row>
                            </CardBody>
                          </Card>
                        </motion.div>
                      </Col>
                    );
                  })}
                {(!props.serversList || !props.serversList.length) && (
                  <div className="m-auto c-white">{t("noServerAvailable")}</div>
                )}
              </Row>
            </CardBody>
          </Card>
        </motion.div>
      </div>
    </>
  );
};

const mapStateToProps = (state) => {
  const { guildsList, selectedGuilds } = state.guilds;
  const { serversList, selectedServer } = state.servers;
  const { listener, vip } = state.infos;
  return {
    guildsList,
    selectedGuilds,
    serversList,
    selectedServer,
    listener,
    vip,
  };
};

const mapDispatchToProps = {
  setupSelectGuild,
  setupSelectServer,
  refreshGuilds,
  deleteServer,
  setListener,
  resync,
};

//export default Setup;
export default connect(mapStateToProps, mapDispatchToProps)(Setup);
